export default "__VITE_ASSET__DryEwtXd__"